// @ts-check

import { mapValues, keyBy, filter, flatMap } from "lodash";

export const buildGroupLookup = ({
  macroAllocationGroups,
  descendantSupplyGroups = undefined,
  relatedSupplyGroups = undefined,
  roleAreaGroups = undefined,
  descendantTargetGroups = undefined,
  relatedBudgetTargetGroups = undefined,
  groupTypes,
}) => {
  return mapValues(
    {
      ...keyBy(macroAllocationGroups, "id"),
      ...keyBy(descendantSupplyGroups, "id"),
      ...keyBy(roleAreaGroups, "id"),
      ...keyBy(relatedSupplyGroups, "id"),
      ...keyBy(descendantTargetGroups, "id"),
      ...keyBy(relatedBudgetTargetGroups, "id"),
    },
    (g) => ({
      ...g,
      isSource: groupTypes[g.type]?.isSupply ?? false,
      isDemand: groupTypes[g.type]?.isDemand ?? false,
    })
  );
};

/**
 * @deprecated
 */
export const buildSourceGroupLookup = ({
  macroAllocationGroups,
  descendantSupplyGroups,
  roleAreaGroups,
  relatedSupplyGroups,
  groupTypes,
}) => {
  return {
    ...keyBy(
      filter(macroAllocationGroups, (g) => groupTypes[g.type]?.isSupply),
      "id"
    ),
    ...keyBy(
      filter(
        flatMap(macroAllocationGroups, (g) => g.parentGroups || []),
        (g) => groupTypes[g.type]?.isSupply
      ),
      "id"
    ),
    ...keyBy(descendantSupplyGroups, "id"),
    ...keyBy(roleAreaGroups, "id"),
    ...keyBy(relatedSupplyGroups, "id"),
  };
};

/**
 * @deprecated
 */
export const buildTargetGroupLookup = ({
  macroAllocationGroups,
  descendantTargetGroups,
  relatedBudgetTargetGroups,
  groupTypes,
}) => {
  // collect all our target groups
  return {
    ...keyBy(
      filter(macroAllocationGroups, (g) => groupTypes[g.type]?.isDemand),
      "id"
    ),
    ...keyBy(
      filter(
        flatMap(macroAllocationGroups, (g) => g.parentGroups || []),
        (g) => groupTypes[g.type]?.isDemand
      ),
      "id"
    ),
    ...keyBy(descendantTargetGroups, "id"),
    ...keyBy(relatedBudgetTargetGroups, "id"),
  };
};
